import _ from 'lodash';

/**
 * The multilang `message` value prefilled from the TDA can carry extra keys
 * (e.g. __typename or languages not part of MultilangAttributesInput), which
 * the mutation would reject as unknown fields — keep only de/en.
 */
export function sanitizeToastMessageInput(input: any) {
    if (_.isPlainObject(input?.message)) {
        return {
            ...input,
            message: _.pick(input.message, ['de', 'en']),
        };
    }
    return input;
}
